import cn from "classnames";
import { ComponentsFromSchema } from "../components-from-schema";
import { FeedbackFormContentProps } from "./types";
import styles from "./styles.scss";

export const FeedbackFormContent = ({
  type,
  data,
  form,
  onChange,
  onSubmit,
  isSubmitDisabled,
}: FeedbackFormContentProps) => (
  <div className={cn(styles.container, styles[type.toLowerCase()])}>
    <ComponentsFromSchema
      schema={data}
      form={form}
      feedbackFormType={type}
      onChange={onChange}
      onSubmit={onSubmit}
      isSubmitDisabled={isSubmitDisabled}
    />
  </div>
);
